module.exports = __webpack_public_path__ + "static/img/ccpv2.8e8cf47.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/products/psLock/ccpt/ccpv2.jpg
// module id = IIcL
// module chunks = 0